import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { useActions } from '@nosto/preact'

import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
import { updateOrderedArray } from "../helpers"



export default ({ facet, isActive, setActive, selectedItems, setSelectedItems}) => {
    const { toggleProductFilter } = useActions()
    //const [active, setActive] = useState(false)
    const isMobile = true;
    const [itemCliked, setItemCliked] = useState(false)
    const selectedFiltersCount =
        facet.data?.filter((v) => v.selected).length ?? 0

    useEffect(() => {
        if (selectedFiltersCount > 0) {
            setActive(true)
        }

    }, [selectedFiltersCount])

    function updateOrderedArray(array, order) {
        console.log("UPDATING ORDERED ARRAY");
        return array.sort((a, b) => order.indexOf(a.value.toUpperCase()) - order.indexOf(b.value.toUpperCase()))
    }
    
    const isSize = facet.name.toLowerCase() === "size"

    if (isSize) {

        let sortIt = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];

        updateOrderedArray(facet.data, sortIt);

        console.log("ORDERED ARRAY", facet.data, updateOrderedArray(facet.data, sortIt));
    }

    return (
        <li class={`ns-sidebar-dropdown group ${isActive ? 'ns-active' : ''}`}
        aria-expanded={isActive ? 'true' : 'false'}
        >
            <a
                class="ns-d-flex ns-justify-content-between ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-pb-4"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={() => {
                    setActive(!isActive)
                }}
            >
                <span class="nosto-facet-name">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                {/* <Icon name="arrow" className="ns-absolute" /> */}
                <span class="accordion__trigger-indicator">
                    <svg aria-label="Plus icon" class="icon icon--plus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.6 0.6H23.4V23.4H0.6V0.6Z" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke" class="icon-outline"></path>
                        <path d="M12 5.45459V12M12 12H5.45459M12 12H18.5455M12 12V18" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke"></path>
                    </svg>

                    <svg aria-label="Minus icon" class="icon icon--minus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.6 0.6H23.4V23.4H0.6V0.6Z" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke" class="icon-outline"></path>
                        <path d="M18.5455 12H5.45459" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke"></path>
                    </svg>
                </span>
            </a>
            <div class="ns-sidebar-submenu ns-d-none  ns-pt-4 ns-pb-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0 nosto-facets-list">
                    {/* {facet.data?.map(value => (
                        <li
                            class="nosto-facet ns-d-flex ns-justify-content-between ns-align-items-center"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            
                        </li>
                    ))} */}
                    {/* {facet.data?.map((value) => {
                        const cleanValue = value.value.replace(/["\[\]]/g, '');
                        return(
                        <li class={
                            !isMobile
                                ? value.selected
                                    ? "nosto-facet ns-d-flex ns-align-items-center ns-relative selected"
                                    : "nosto-facet ns-d-flex ns-align-items-center ns-relative"
                                : selectedItems.some(item => item.facet === facet.field && item.value === value.value)
                                    ? "nosto-facet ns-d-flex ns-align-items-center ns-relative selected"
                                    : "nosto-facet ns-d-flex ns-align-items-center ns-relative"
                        }
                        onChange={(e) => {
                            e.preventDefault();
                            if (isMobile) {
                                const newItem = { facet: facet.field, value: value.value, selected: !value.selected };
                                const itemIndex = selectedItems.findIndex(item => item.facet === newItem.facet && item.value === newItem.value);
                                if (itemIndex !== -1) {
                                    setSelectedItems(prevItems => prevItems.filter((_, index) => index !== itemIndex));
                                } else {
                                    setSelectedItems(prevItems => [...prevItems, newItem]);
                                }
                            } else {
                                toggleProductFilter(facet.field, value.value, !value.selected);
                            }
                        }}
                        data-nosto-element="facet-setting">
                                <input id="" class="dot-checkbox" type="checkbox" name={value.value} 
                                value={value.value} 
                                checked={selectedItems.some(item => item.facet === facet.field && item.value === value.value)}
                                ></input>
                            <label class="facet-label ns-checkbox ns-d-block">
                                {cleanValue}
                                <input
                                    type="checkbox"
                                    checked={selectedItems.some(item => item.facet === facet.field && item.value === value.value)}
                                />
                            </label>
                            
                        </li>
                        )}
                    )} */}
                    {facet.data?.map(value => (
                        <li
                        // class="nosto-facet ns-d-flex ns-justify-content-between ns-align-items-center"
                        class="results-filter__filter-value results-filter__filter-value--color facet-nosto"
                        data-nosto-element="facet-setting"
                    >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-font-3 ns-font-bold ns-color-black ns-background-grey-light ns-border-radius-3">
                                {value.count}
                            </span> */}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
